export interface AuthState {
  isAuthenticated: boolean;
  persona_id: number;
  token: string;
  user: User | null;
  error: string | null;
  isLoading: boolean;
}

export interface User {
  id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  pk?: number;
  password?: string;
  token?: string;
}

export function createUser(): User {
  return {
      id: null,
      username: null,
      email: null,
      first_name: null,
      last_name: null,
      pk: null,
      password: null,
      token: null
  };
}

export function copyUser(user: User): User {
  return {...user};
}
